// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6a921649","498":"91bc6c60","703":"20520fea","787":"7e0cbfda"}[chunkId] + ".chunk.js";
};